import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import api from '../../api';
import { RootState } from "../../store";
import { revokeAlertusTokenUrl } from "../../config";

const DELETE_TOKEN = "deletePublicApiToken";

interface IDeleteAlertusTokenPayload {
  entryId: string;
  orgId: string;
}

interface IDeleteAlertusTokenResponse {
  message: string;
}

interface IDeleteAlertusTokenState {
  status: string;
  error: string | null;
  msg: string | null;
}

const initialState: IDeleteAlertusTokenState = {
  status: Status.IDLE,
  error: null,
  msg: null,
};

export const deleteAlertusToken = createAsyncThunk(
  DELETE_TOKEN,
  async (payload: IDeleteAlertusTokenPayload, { rejectWithValue }) => {
    try {
      const response = await api.delete<IDeleteAlertusTokenResponse>(
        `${revokeAlertusTokenUrl}?entryId=${payload.entryId}`, {data: {orgId: payload.orgId}}
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

const deleteAlertusTokenSlice = createSlice({
  name: DELETE_TOKEN,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteAlertusToken.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
        state.error = null;
      })
      .addCase(deleteAlertusToken.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.msg = (action.payload as IDeleteAlertusTokenResponse).message;
      })
      .addCase(deleteAlertusToken.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { message?: string } } };
        state.status = Status.FAILED;
        state.error = errorPayload?.response?.data?.message || action.error.message || 'Unknown error';
      });
  },
});

export const selector = (state: RootState) => state.deleteAlertusToken;

export default deleteAlertusTokenSlice.reducer;
